<template>
    <div class="section section__title grid" :id="content.anchor">
        <h1 class="section--title" v-text="content.title"></h1>
        <div class="section--lead" v-html="content.lead"></div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import cmsPlugin from 'vue/mixins/cms/cms-plugin';
    import uuidMixin from 'vue/mixins/uuid';


    export default {
        mixins: [
            uuidMixin,
            cmsPlugin,
        ],
        methods: {
            ...mapActions(['updateTitleSection', 'removeTitleSection']),
            updateNav() {
                this.updateTitleSection({
                    section: {
                        uuid: this.uuid,
                        title: this.content.title,
                    },
                });
            },
        },
        watch: {
            content: {
                handler() {
                    this.updateNav();
                },
                deep: true,
                immediate: true,
            },
        },
        beforeDestroy() {
            this.removeTitleSection({
                section: {
                    uuid: this.uuid,
                },
            });
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?0c3dea47